/**
 * NAKİT TAKİBİ — kasa (profil) düzeyinde açılıp kapatılır (kullanıcı kararı
 * 14.10.2026). Herkes nakdini izlemek istemez: yatırma/çekme yazmayan bir
 * defterde "net nakit hareketi" negatif çıkar ve kafa karıştırır.
 *
 * NEREDE: profilin ŞİFRELİ kabında (`repo.settings`), tarayıcının düz
 * depolamasında DEĞİL — defterle ilgili bir tercih.
 *
 * VARSAYILAN "otomatik" (kullanana açık): defterde bir yatırma ya da
 * çekme satırı varsa açık, yoksa kapalı. Kullanıcı açıkça "açık"/"kapalı"
 * seçerse o geçerli. Motor yalnızca açık/kapalı bilir
 * (`ValuationOptions.nakitTakibi`); bu karar burada.
 */

import type { LocalRepository } from "@parafon/contracts/local-api";
import { M } from "../dil";

export const NAKIT_TAKIBI_AYARI = "nakitTakibi";

export type NakitTakibiSecimi = "kendiliginden" | "acik" | "kapali";

export const NAKIT_TAKIBI_SECENEKLERI: readonly { readonly value: NakitTakibiSecimi; readonly label: string }[] = [
  { value: "kendiliginden", label: M.hareketler.nakitTakibi.kendiliginden },
  { value: "acik", label: M.hareketler.nakitTakibi.acik },
  { value: "kapali", label: M.hareketler.nakitTakibi.kapali },
];

/** Kayıt yoksa ya da tanınmıyorsa "kendiliğinden". */
export function nakitSecimiOku(kayit: string | null): NakitTakibiSecimi {
  return kayit === "acik" || kayit === "kapali" ? kayit : "kendiliginden";
}

/** Defterde sermaye hareketi (yatırma/çekme) var mı — tek satırlık sorgu. */
async function sermayeHareketiVar(repo: LocalRepository): Promise<boolean> {
  const sayfa = await repo.transactions.query({ types: ["DEPOSIT", "WITHDRAWAL"], limit: 1 });
  return sayfa.total > 0;
}

export interface NakitTakibiDurumu {
  readonly secim: NakitTakibiSecimi;
  /** Fiilen açık mı (kendiliğinden ise defterden çözülmüş hâli). */
  readonly acik: boolean;
}

export async function nakitTakibiDurumu(repo: LocalRepository): Promise<NakitTakibiDurumu> {
  const secim = nakitSecimiOku(await repo.settings.get(NAKIT_TAKIBI_AYARI).catch(() => null));
  if (secim !== "kendiliginden") return { secim, acik: secim === "acik" };
  return { secim, acik: await sermayeHareketiVar(repo) };
}
